import { render, staticRenderFns } from "./VAttribute.vue?vue&type=template&id=12d7af8a"
import script from "./VAttribute.vue?vue&type=script&lang=js"
export * from "./VAttribute.vue?vue&type=script&lang=js"
import style0 from "./VAttribute.vue?vue&type=style&index=0&id=12d7af8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports